import React from 'react';

interface BadgeProps {
  text: string;
  icon: string;
}

const Badge: React.FC<BadgeProps> = ({ text, icon }) => {
  return (
    <div className="inline-flex items-center gap-2 whitespace-nowrap rounded-lg border border-solid border-black px-3 py-1.5 font-interBold text-sm leading-none tracking-normal text-black">
      <img
        loading="lazy"
        src={`/assets/icons/${icon}_spice.svg`}
        alt=""
        className="my-auto aspect-[0.55] w-[16px] shrink-0 self-stretch object-contain"
      />
      <span className="my-auto self-stretch">{text}</span>
    </div>
  );
};

export default Badge;
